// @flow
import React from 'react';
import Activity from 'brastrap/common/activity/Activity';
import MapWithAMarker from './MapWithAMarker';
import type { GoogleMapProps as Props } from './map.types';

const GoogleMap = (props: Props) => {
  const sizedDiv = <div style={{ height: props.height, width: props.width }} />;
  return (
    <MapWithAMarker
      googleMapURL={`https://maps.googleapis.com/maps/api/js?libraries=places&key=${props.googleApiKey}`}
      loadingElement={
        <div
          className="c-map__loading"
          style={{ height: props.height, width: props.width }}
        >
          <Activity />
        </div>
      }
      containerElement={sizedDiv}
      mapElement={sizedDiv}
      zoom={props.zoom}
      showAllMarkup={props.showAllMarkup}
      shops={props.shops}
    />
  );
};

GoogleMap.defaultProps = {
  zoom: 6,
  showAllMarkup: false,
  width: 720,
  height: 400,
  shops: [],
};

export default GoogleMap;
